/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope), and are owned by the cards this row holds. */

/* The aside takes the left quarter — wide enough for a list of labels — with
   the main content taking the rest. They stack on narrow pages.
   minmax(0, …) lets the aside hold its quarter: a bare 1fr is floored by the
   card's own content width. */
.row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 3fr;
  gap: var(--spacing-6);
}

@media (max-width: 1100px) {
  .row {
    grid-template-columns: 1fr;
  }
}
